import * as InfoMessage from "../../../../src/Components/Modals/InfoMessage/InfoMessage.scss";
import { Record, Union } from "../../../fable_modules/fable-library.3.7.20/Types.js";
import { record_type, lambda_type, unit_type, class_type, string_type, union_type } from "../../../fable_modules/fable-library.3.7.20/Reflection.js";
import { stripHtmlTags, classNames } from "../../../Utils.js";
import { uncurry, equals } from "../../../fable_modules/fable-library.3.7.20/Util.js";
import { ofArray } from "../../../fable_modules/fable-library.3.7.20/List.js";
import { getMaterialIcon } from "../../../ViewUtils.js";
import * as react from "react";
import { modal } from "../../Modal/Modal.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";


export class MessageType extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Info", "Warning", "Error"];
    }
}

export function MessageType$reflection() {
    return union_type("Components.Modals.InfoMessage.MessageType", [], MessageType, () => [[], [], []]);
}

function renderHeader(header, messageType, onConfirm) {
    let children_2, children, children_6, children_4;
    const iconClasses = classNames(ofArray([["message-icon", true], ["message-icon--info", equals(messageType, new MessageType(0))], ["message-icon--warning", equals(messageType, new MessageType(1))], ["message-icon--error", equals(messageType, new MessageType(2))]]));
    const children_10 = [(children_2 = [(children = [getMaterialIcon("close")], react.createElement("span", {
        className: "message-icon",
        onClick: onConfirm,
    }, ...children))], react.createElement("div", {
        className: "message-container__close",
    }, ...children_2)), (children_6 = [(children_4 = [getMaterialIcon("error")], react.createElement("span", {
        className: iconClasses,
    }, ...children_4))], react.createElement("div", {
        className: "message-container__icon",
    }, ...children_6)), react.createElement("h1", {
        className: "message__header",
    }, header)];
    return react.createElement("div", {
        className: "message-container__header",
    }, ...children_10);
}

function renderBody(bodyHtml) {
    return react.createElement("div", {
        className: "message-container__body",
    }, bodyHtml);
}

function renderButton(confirmButtonText, onConfirm) {
    const children_2 = [react.createElement("button", {
        className: "message-button message-button--confirm",
        onClick: onConfirm,
    }, confirmButtonText)];
    return react.createElement("div", {
        className: "message__buttons",
    }, ...children_2);
}

export function render(header, bodyHtml, messageType, buttonConfirm, onConfirm) {
    const children = [renderHeader(header, messageType, onConfirm), renderBody(bodyHtml), renderButton(buttonConfirm, onConfirm)];
    return react.createElement("div", {
        className: "message-container",
    }, ...children);
}

export function renderAsModal(header, bodyHtml, messageType, buttonConfirm, onConfirm) {
    return modal(true, render(header, bodyHtml, messageType, buttonConfirm, onConfirm));
}

export class ErrorModalProps extends Record {
    constructor(Message, CloseFn, GetTranslationFn) {
        super();
        this.Message = Message;
        this.CloseFn = CloseFn;
        this.GetTranslationFn = GetTranslationFn;
    }
}

export function ErrorModalProps$reflection() {
    return record_type("Components.Modals.InfoMessage.ErrorModalProps", [], ErrorModalProps, () => [["Message", string_type], ["CloseFn", lambda_type(class_type("Browser.Types.MouseEvent", void 0, MouseEvent), unit_type)], ["GetTranslationFn", lambda_type(string_type, string_type)]]);
}

export const renderErrorModal = FunctionComponent_Of_Z5A158BBF((props) => {
    let children;
    const isOpenState = react.useState(true);
    if (isOpenState[0]) {
        return modal(true, render("Error", (children = [stripHtmlTags(props.Message.split(""))], react.createElement("div", {}, ...children)), new MessageType(2), props.GetTranslationFn("Common.Close"), (e) => {
            isOpenState[1](false);
            props.CloseFn(e);
        }));
    }
    else {
        return react.createElement(react.Fragment, {});
    }
}, void 0, uncurry(2, void 0), void 0, "renderErrorModal", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Components\\Modals\\InfoMessage\\InfoMessage.fs", 88);

